module.exports = __webpack_public_path__ + "img/icon-whatsapp.2fb2462a.png";